export const ORDER_SUCCESS = 'ORDER_SUCCESS';

export const ORDER_FAILED = 'ORDER_FAILED';

export const CLOSE_ORDER_POPUP = 'CLOSE_ORDER_POPUP';

export const ORDER_TERMS_INFO = 'ORDER_TERMS_INFO';

export const ARORDER_TERMS_INFO = 'ARORDER_TERMS_INFO';

export const SET_IS_ORDERTERMS_LOADING = 'SET_IS_ORDERTERMS_LOADING';

export const LOAD_SUGGESTED_SHIP_ADDRESS = 'LOAD_SUGGESTED_SHIP_ADDRESS';



// WEBPACK FOOTER //
// ./src/store/actions/types/orderActionTypes.js